module.exports = __webpack_public_path__ + "img/heic.41fa1789.png";